import { StyledFlex, StyledGridCol, StyledGridRow } from "@/common/styles";
import Button from "@/common/elements/Button";
import { useEffect, useState } from "react";
import Modal from "@/common/elements/Modal";
import Table from "@/common/elements/Table";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Checkbox from "antd/es/checkbox/Checkbox";
import AddressesList from "./PersonalInformationDetails/AddressesList";
import { BookingsSectionTitle } from "./styles";
import PersonalBasicInformation from "./PersonalInformationDetails/PersonalBasicInformation";
import AliasesList from "./PersonalInformationDetails/AliasesList";
import TextField from "@/common/elements/InputElements/TextField";
import { Col, Row } from "react-bootstrap";
import { TableHeader } from "../InmateDetails/styles";
import VictimNotificationAttemptForm from "./VictimNotificationAttemptForm";
import FolderDetailSearchModal from "../FolderDetailSearch/FolderDetailSearchModal";
import { Form, Popconfirm } from "antd";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { v4 as uuidv4 } from "uuid";
import { setBookings, setDeleteAPis } from "@/slices/bookingsSlice";
import Select from "@/common/elements/InputElements/Select";
import {
  getOptionsFromRefList,
  hasCheckSecurity,
} from "@/util/common_function";
import API_ENDPOINTS from "@/util/api";
import useDialog from "@/hooks/useDialog";
import CommonDatePicker from "@/common/elements/DatePicker";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import {
  MODULES_LIST_WITH_ID,
  SUB_MODULES_LIST_WITH_ID,
} from "@/util/common_variable";

const VictimNotificationDetails = () => {
  const [victimNotificationForm] = Form.useForm();
  const currentUser = JSON.parse(localStorage.getItem("userDetails"));
  const dispatch = useDispatch();
  const { showDialog } = useDialog();
  const { bookings, bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings
  );

  const [showVictimNotifyTable, setShowVictimNotifyTable] = useState(false);
  const [showVictimNotification, setShowVictimNotification] = useState(false);
  const [notificationAttemptModal, setNotificationAttemptModal] =
    useState(false);
  const [isFolderSearchModal, setIsFolderSearchModal] = useState(false);
  const [victimNotifiTableList, setVictimNotifiTableList] = useState([]);
  const [victimNotificationID, setVictimNotificationID] = useState(null);
  const [victimLogID, setVictimLogID] = useState(null);
  const [selectedRow, setSelectedRow] = useState();
  const [selectedVictimLog, setSelectedVictimLog] = useState(null);
  const [vicitimLogTable, setVictimLogTable] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  // Local state for personal details (selectedAliases and addresses)
  const [selectedAliases, setSelectedAliases] = useState(
    selectedRow?.jackets?.[0]?.bio?.[0]?.bioAliases || []
  );
  const [addresses, setAddresses] = useState(
    selectedRow?.jackets?.[0]?.bio?.[0]?.bioAddresses || []
  );

  useEffect(() => {
    setShowVictimNotifyTable(bookings?.victimNotifications?.length > 0);
  }, [bookingsFieldsEnabled, bookings?.victimNotifications]);

  useEffect(() => {
    victimNotificationForm.setFieldsValue({ bioAliases: selectedAliases });
  }, [selectedAliases, victimNotificationForm]);

  useEffect(() => {
    victimNotificationForm.setFieldsValue({ bioAddresses: addresses });
  }, [addresses, victimNotificationForm]);

  useEffect(() => {
    setVictimNotifiTableList(
      (bookings?.victimNotifications || [])
        .map((item) => ({ ...item }))
        .sort((a, b) => {
          const idA = Number(a.victimNotificationID) || Number.MAX_SAFE_INTEGER;
          const idB = Number(b.victimNotificationID) || Number.MAX_SAFE_INTEGER;
          return idA - idB;
        })
    );
  }, [bookings?.victimNotifications]);

  useEffect(() => {
    if (selectedRow) {
      let tableData = [...(selectedRow?.victimNotificationLog || [])];
      setVictimLogTable(
        tableData.map((item) => {
          return {
            ...item,
            methodLbl: getOptionsFromRefList(
              "VictimNotification_Method",
              false,
              false,
              true
            )?.filter((data) => data.value == item.method)?.[0]?.label,
            successful: item.successful ? "True" : "False",
          };
        })
      );

      setSelectedAliases(selectedRow?.jackets?.[0]?.bio?.[0]?.bioAliases || []);
      setAddresses(selectedRow?.jackets?.[0]?.bio?.[0]?.bioAddresses || []);
    } else {
      victimNotificationForm.resetFields();
    }
  }, [selectedRow]);

  useEffect(() => {
    if (vicitimLogTable && vicitimLogTable?.length > 0) {
      const lastLog = vicitimLogTable[vicitimLogTable?.length - 1];
      if (lastLog.successful === "True") {
        victimNotificationForm.setFieldsValue({ status: "Notified" });
      } else {
        victimNotificationForm.setFieldsValue({ status: "Not Notified" });
      }
    } else {
      // Optionally, if there are no logs, set a default status.
      victimNotificationForm.setFieldsValue({ status: "Not Notified" });
    }
  }, [vicitimLogTable, victimNotificationForm]);

  const handleNotificationAttemptModal = () => {
    setNotificationAttemptModal(!notificationAttemptModal);
  };
  const clickVictimNotification = (isEdit) => {
    setShowVictimNotification(true);
    if (!isEdit) {
      setTimeout(() => {
        setIsFolderSearchModal(true);
      }, 700);
    }
  };
  const VictimNotificationTable = {
    headers: [
      { key: "status", text: "Status" },
      { key: "lName", text: "Last Name" },
      { key: "fName", text: "First Name" },
      { key: "mName", text: "Middle Name" },
      { key: "daytimePhone", text: "Work Phone" },
      { key: "phone", text: "Home Phone" },
      { key: "comments", text: "Comments" },
    ],
    rows: [],
  };

  const addNotification = () => {
    victimNotificationForm.setFieldsValue({
      comments: null,
      status: "Not Notified",
      jackets: [
        {
          bio: [
            {
              dlNumber: "",
              dlState: null,
              dlExpiration: null,
              ssn: "",
              dob: null,
              ageAtEntry: "",
            },
          ],
        },
      ],
    });

    // Clear any previous personal information selections.
    setSelectedAliases([]);
    setAddresses([]);
    setSelectedRow(null);
    setVictimNotificationID(null);
    setVictimLogTable([]);
    clickVictimNotification();
  };
  const handleSelectCurrentJacket = (selectedFolder) => {
    if (!selectedFolder) {
      alert("Please select a folder from the list first.");
      return;
    }
    const folderData = selectedFolder.originalData;
    const associateFromFolder = {
      uuid: folderData?.associatedWithJacketID || uuidv4(),
      associateTypeID: folderData?.associateType,
      jacketID: folderData?.jacketId,
      bioID: folderData?.jackets?.bioId,
      jackets: folderData?.jackets
        ? [folderData?.jackets]
        : [{ staffJacket: false, orphanFlag: false, bio: [selectedFolder] }],
    };
    const parsedDOB = folderData?.jackets?.bio?.[0]?.dob
      ? dayjs(folderData?.jackets.bio[0].dob, "MM/DD/YYYY")
      : null;
    const age = parsedDOB ? dayjs().diff(parsedDOB, "year") : "";
    victimNotificationForm.setFieldsValue({
      jackets: [
        {
          bio: [
            {
              dlNumber: folderData?.jackets.bio?.[0]?.dlNumber,
              dlState: folderData?.jackets?.bio?.[0]?.dlState,
              dlExpiration: folderData?.jackets?.bio?.[0]?.dlExpiration
                ? dayjs(folderData?.jackets.bio[0].dlExpiration, "MM/DD/YYYY")
                : null,
              ssn: folderData?.jackets?.bio?.[0]?.ssn,
              dob: parsedDOB,
              ageAtEntry: age,
            },
          ],
        },
      ],
    });

    setSelectedRow(associateFromFolder);
    setIsFolderSearchModal(false);
  };

  const patchVictimData = (item) => {
    setVictimLogTable([]);
    setSelectedRow(item);
    setVictimNotificationID(item.victimNotificationID || item.id);
    // If personal details are stored on the item, set them into local state.
    if (item?.jackets?.[0]?.bio?.[0]?.bioAliases) {
      setSelectedAliases(item?.jackets?.[0]?.bio?.[0]?.bioAliases);
    }
    if (item?.jackets?.[0]?.bio?.[0]?.bioAddresses) {
      setAddresses(item?.jackets?.[0]?.bio?.[0]?.bioAddresses);
    }
  };

  const viewVictimDetails = () => {
    setIsEdit(true);
    // Create a shallow clone of selectedRow, then clone its jackets array if it exists
    const dataToSet = {
      ...selectedRow,
      jackets: selectedRow.jackets ? [...selectedRow.jackets] : [],
    };

    // If there is at least one jacket, clone its bio array
    if (dataToSet.jackets[0]) {
      dataToSet.jackets[0] = {
        ...dataToSet.jackets[0],
        bio: dataToSet.jackets[0].bio ? [...dataToSet.jackets[0].bio] : [],
      };

      // If there is at least one bio entry, clone and update it
      if (dataToSet.jackets[0].bio[0]) {
        const bioData = { ...dataToSet.jackets[0].bio[0] };

        // Convert the date strings into dayjs objects using the same format
        if (bioData.dlExpiration) {
          bioData.dlExpiration = dayjs(bioData.dlExpiration, "MM/DD/YYYY");
        }
        if (bioData.dob) {
          bioData.dob = dayjs(bioData.dob, "MM/DD/YYYY");
        }

        // Assign the updated bioData back to the new bio array
        dataToSet.jackets[0].bio[0] = bioData;
      }
    }

    // Set the processed values into the form
    victimNotificationForm.setFieldsValue(dataToSet);
    clickVictimNotification(true);
  };

  const saveNotificationLog = () => {
    if (!selectedVictimLog) return;
    setSelectedRow((prev) => {
      const value = {
        ...selectedVictimLog,
        dateNotified: dayjs(
          selectedVictimLog.dateTimeNotified || new Date()
        ).format("MM/DD/YYYY"),
        timeNotified: dayjs(
          selectedVictimLog.dateTimeNotified || new Date()
        ).format("HH:mm"),
      };
      return {
        ...prev,
        victimNotificationLog: victimLogID
          ? prev?.victimNotificationLog.map((p) =>
              p?.id === victimLogID ||
              p?.victimNotificationLogID === victimLogID
                ? value
                : p
            )
          : [
              ...(prev?.victimNotificationLog || []),
              { ...value, id: uuidv4() },
            ],
      };
    });
    handleNotificationAttemptModal();
  };

  const updateFormValue = (field) => {
    const key = Object.keys(field)?.[0];
    setSelectedVictimLog((prev) => ({
      ...prev,
      [key]: field[key],
    }));
  };

  const saveVictimNotification = async () => {
    try {
      const values = await victimNotificationForm.validateFields();
      const jacketData = values.jackets?.[0]?.bio?.[0];
      const bio = {
        lName: values.lName,
        fName: values.fName,
        mName: values.mName,
        suffix: values.suffix,
        daytimePhone: values.daytimePhone,
        phone: values.phone,
        bioAliases: values.bioAliases || [],
        bioAddresses: values.bioAddresses || [],
        ...jacketData,
        dlExpiration: jacketData?.dlExpiration
          ? dayjs(jacketData.dlExpiration).format("MM/DD/YYYY")
          : null,
        dob: jacketData?.dob
          ? dayjs(jacketData.dob).format("MM/DD/YYYY")
          : null,
        ageAtEntry: jacketData?.ageAtEntry,
      };

      // Create a jacket object containing the bio information
      const jacket = {
        jacketId: selectedRow?.jacketID, // Use existing jacketId if available
        bioId: selectedRow?.bioID,
        bio: [bio],
      };

      const tempData = {
        ...values,
        victimNotificationLog: selectedRow?.victimNotificationLog,
        jacketID: selectedRow?.jacketID, // Use existing jacketId if available
        bioID: selectedRow?.bioID,
        jackets: [jacket],
      };

      const updatedData = victimNotificationID
        ? victimNotifiTableList.map((p) =>
            p?.victimNotificationID === victimNotificationID ||
            p?.id === victimNotificationID
              ? { ...p, ...tempData }
              : p
          )
        : [...victimNotifiTableList, { ...tempData, id: uuidv4() }];

      updateStorData(updatedData);
      setShowVictimNotification(false);
    } catch (error) {
      console.error(error);
    }
  };

  const addNotificationLog = () => {
    setSelectedVictimLog(null);
    setVictimLogID(null);
    handleNotificationAttemptModal();
  };

  const deleteVictimLog = () => {
    setSelectedRow((prevRow) => ({
      ...prevRow,
      victimNotificationLog:
        prevRow?.victimNotificationLog?.filter(
          (item) =>
            item?.victimNotificationLogID !== victimLogID &&
            item?.id !== victimLogID
        ) || [],
    }));
    setSelectedVictimLog(null);
    setVictimLogID(null);
  };

  const deleteVictimNotify = () => {
    updateStorData(
      victimNotifiTableList.filter(
        (item) =>
          item?.victimNotificationID !== victimNotificationID &&
          item?.id !== victimNotificationID
      )
    );
    const url = API_ENDPOINTS.victimLog + "/id/" + victimNotificationID;
    dispatch(setDeleteAPis(url));
    setVictimNotificationID(null);
    setSelectedRow(null);
  };

  const updateStorData = (tb) => {
    dispatch(
      setBookings({
        victimNotifications: [...tb],
      })
    );
  };

  const cancelAction = () => {
    setSelectedRow(null);
    setVictimNotificationID("");
    setShowVictimNotification(false);
    setIsEdit(false);
  };
  useEffect(() => {
    if (isEdit) {
      let isShow = hasCheckSecurity(
        Security_Types.functionality,
        Entity_types.subModule,
        LABELS_CAPITAL.MODIFY,
        MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
        SUB_MODULES_LIST_WITH_ID.Arrest_Report
      );
      if (isShow) {
        setIsDisabled(false);
      } else {
        setIsDisabled(true);
      }
    } else {
      setIsDisabled(false);
    }
  }, [isEdit]);
  useEffect(() => {
    console.log({ isDisabled });
  }, [isDisabled]);
  return (
    <>
      <StyledGridRow justify={"start"}>
        <StyledGridCol xs={12} sm={6} md={6} lg={6}>
          <FormItem
            label="Notify Victims?"
            layout="horizontal"
            className="form-item-checkbox-left"
            valuePropName="checked"
            disabled={
              !bookingsFieldsEnabled || victimNotifiTableList?.length > 0
            }
          >
            <Checkbox
              id="dropletPrecautions"
              disabled={
                !bookingsFieldsEnabled || victimNotifiTableList?.length > 0
              }
              checked={
                showVictimNotifyTable || victimNotifiTableList?.length > 0
              }
              name="Droplet Precautions"
              onChange={(e) => setShowVictimNotifyTable(e?.target?.checked)}
            />
          </FormItem>
        </StyledGridCol>
      </StyledGridRow>

      {showVictimNotifyTable && (
        <>
          <StyledFlex gap={"10px"} justify="flex-end">
            <Button
              disabled={
                !bookingsFieldsEnabled ||
                !hasCheckSecurity(
                  Security_Types.functionality,
                  Entity_types.subModule,
                  LABELS_CAPITAL.ADD,
                  MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                  SUB_MODULES_LIST_WITH_ID.Arrest_Report
                )
              }
              onClick={addNotification}
            >
              ADD
            </Button>
            <Button
              disabled={
                !victimNotificationID ||
                victimNotifiTableList?.length === 0 ||
                !hasCheckSecurity(
                  Security_Types.functionality,
                  Entity_types.subModule,
                  LABELS_CAPITAL.VIEW,
                  MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                  SUB_MODULES_LIST_WITH_ID.Arrest_Report
                )
              }
              onClick={viewVictimDetails}
            >
              Details
            </Button>
            <Button
              disabled={
                !victimNotificationID || victimNotifiTableList?.length === 0
              }
              onClick={cancelAction}
            >
              Cancel
            </Button>
            <Popconfirm
              title="Delete the VictimNotification"
              description="Are you sure to delete this VictimNotification?"
              onConfirm={deleteVictimNotify}
              onCancel={() => {}}
              okText="Yes"
              cancelText="No"
            >
              <Button
                color="primary"
                type="primary"
                disabled={
                  !victimNotificationID ||
                  victimNotifiTableList?.length === 0 ||
                  !hasCheckSecurity(
                    Security_Types.functionality,
                    Entity_types.subModule,
                    LABELS_CAPITAL.DELETE,
                    MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                    SUB_MODULES_LIST_WITH_ID.Arrest_Report
                  )
                }
              >
                Delete
              </Button>
            </Popconfirm>
          </StyledFlex>
          {hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report
          ) && (
            <Table
              headers={VictimNotificationTable.headers}
              data={(victimNotifiTableList || []).map((item) => ({
                ...item,
                status: item.status || "",
                lName: item.jackets?.[0]?.bio?.[0]?.lName || "",
                fName: item.jackets?.[0]?.bio?.[0]?.fName || "",
                mName: item.jackets?.[0]?.bio?.[0]?.mName || "",
                daytimePhone: item.jackets?.[0]?.bio?.[0]?.daytimePhone || "",
                phone: item.jackets?.[0]?.bio?.[0]?.phone || "",
                comments: item.comments || "",
              }))}
              style={{ marginTop: "15px" }}
              onRowClick={patchVictimData}
              selected={selectedRow === null}
            />
          )}
        </>
      )}

      {showVictimNotification && (
        <Modal
          header={"Victim Notification"}
          show={showVictimNotification}
          size="xl"
          onHide={cancelAction}
          footerActions={[
            {
              key: "save",
              text: "Save",
              onClick: saveVictimNotification,
              disabled: isDisabled,
            },
          ]}
          footerCloseAction={() => setIsEdit(false)}
          footerCloseActionText="Close"
        >
          <Form
            form={victimNotificationForm}
            initialValues={{
              jackets: [
                {
                  bio: [
                    {
                      dob: null,
                      dlExpiration: null,
                      ageAtEntry: undefined,
                    },
                  ],
                },
              ],
            }}
            onValuesChange={(changedValues, allValues) => {
              const updatedDOB = changedValues?.jackets?.[0]?.bio?.[0]?.dob;
              if (updatedDOB) {
                const parsedDOB = dayjs.isDayjs(updatedDOB)
                  ? dayjs(updatedDOB)
                  : dayjs(updatedDOB, "MM/DD/YYYY");
                const age = dayjs().diff(parsedDOB, "year");

                const currentJackets = allValues.jackets || [];
                if (currentJackets.length > 0) {
                  const currentBio = currentJackets[0].bio || [];
                  if (currentBio.length > 0) {
                    currentBio[0] = { ...currentBio[0], ageAtEntry: age };
                  } else {
                    currentJackets[0].bio = [{ ageAtEntry: age }];
                  }
                } else {
                  currentJackets.push({ bio: [{ ageAtEntry: age }] });
                }

                victimNotificationForm.setFieldsValue({
                  jackets: currentJackets,
                });
              }
            }}
          >
            <BookingsSectionTitle>
              <span>Personal Information</span>
            </BookingsSectionTitle>
            {/* Personal Basic Information */}

            <PersonalBasicInformation
              selectedAssociate={selectedRow?.jackets?.[0]?.bio?.[0]}
              form={victimNotificationForm}
              associates={true}
            />

            {/* Personal selectedAliases */}
            <AliasesList
              showQuickAddForm={false}
              selectedAliases={selectedAliases}
              associates={true}
              onAliasesChange={setSelectedAliases}
            />
            {/* Hidden field to pass selectedAliases */}
            <FormItem name="bioAliases" hidden>
              <TextField />
            </FormItem>

            {/* Personal Addresses */}
            <AddressesList
              selectedAddresses={addresses}
              associates={true}
              onAddressesChange={setAddresses}
            />
            {/* Hidden field to pass addresses */}
            <FormItem name="bioAddresses" hidden>
              <TextField value={addresses} />
            </FormItem>

            <StyledGridRow gutter={16}>
              <StyledGridCol>
                <FormItem
                  label="Drivers License"
                  name={["jackets", 0, "bio", 0, "dlNumber"]}
                >
                  <TextField />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol>
                <FormItem
                  label="DL State"
                  name={["jackets", 0, "bio", 0, "dlState"]}
                >
                  <Select
                    id="dlState"
                    options={getOptionsFromRefList("USState")}
                    placeholder="State"
                  />
                </FormItem>
              </StyledGridCol>

              <StyledGridCol>
                <FormItem
                  label="Expires"
                  name={["jackets", 0, "bio", 0, "dlExpiration"]}
                >
                  <CommonDatePicker format="MM/DD/YYYY" showTime={false} />
                </FormItem>
              </StyledGridCol>

              <StyledGridCol>
                <FormItem label="SSN" name={["jackets", 0, "bio", 0, "ssn"]}>
                  <TextField />
                </FormItem>
              </StyledGridCol>

              <StyledGridCol>
                <FormItem label="DOB" name={["jackets", 0, "bio", 0, "dob"]}>
                  <CommonDatePicker
                    format="MM/DD/YYYY"
                    showTime={false}
                    disableFutureDates={true}
                  />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol>
                <FormItem
                  label="AGE"
                  name={["jackets", 0, "bio", 0, "ageAtEntry"]}
                >
                  <TextField disabled={true} />
                </FormItem>
              </StyledGridCol>
            </StyledGridRow>

            <BookingsSectionTitle>
              <span>Notification Information</span>
            </BookingsSectionTitle>
            <StyledGridRow gutter={16}>
              <StyledGridCol>
                <FormItem label="Status" name="status">
                  <TextField disabled />
                </FormItem>
              </StyledGridCol>
            </StyledGridRow>
            <Row gutter={16}>
              <Col span={8}>
                <FormItem label="Comments" name="comments">
                  <TextField
                    inputType="textarea"
                    as="textarea"
                    id="description"
                    name="description"
                    variant="outlined"
                    rows="5"
                  />
                </FormItem>
              </Col>
            </Row>

            <BookingsSectionTitle>
              <span>Victim Notification Attempts</span>
            </BookingsSectionTitle>

            <TableHeader>
              <h6>Victim Notification Attempts</h6>
              <div className="right">
                <Button onClick={addNotificationLog}> Add </Button>
                <Button
                  disabled={!victimLogID}
                  onClick={handleNotificationAttemptModal}
                  style={{ marginLeft: "10px" }}
                >
                  Details
                </Button>
                <Popconfirm
                  title="Delete the VictimNotification Log"
                  description="Are you sure to delete this VictimNotification log?"
                  onConfirm={deleteVictimLog}
                  onCancel={() => {}}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button
                    color="primary"
                    type="primary"
                    style={{ marginLeft: "10px" }}
                    disabled={!victimLogID || vicitimLogTable?.length === 0}
                  >
                    Delete
                  </Button>
                </Popconfirm>
              </div>
            </TableHeader>

            <Table
              variant="outlined"
              style={{ padding: "unset" }}
              headers={[
                { key: "successful", text: "Successful" },
                { key: "methodLbl", text: "Method" },
                { key: "notifyingOfficerStaffID", text: "Staff Description" },
                { key: "dateNotified", text: "Date Notified" },
                { key: "timeNotified", text: "Time Notified" },
              ]}
              data={(vicitimLogTable || []).map((row) => ({
                ...row,
                notifyingOfficerStaffID:
                  getOptionsFromRefList("Notifying_Officer", true)?.find(
                    (item) => item.value === row.notifyingOfficerStaffID
                  )?.label || row.notifyingOfficerStaffID,
              }))}
              onRowClick={(data) => {
                setSelectedVictimLog(data);
                setVictimLogID(data?.victimNotificationLogID || data.id);
              }}
            />
          </Form>
        </Modal>
      )}

      {notificationAttemptModal && (
        <Modal
          header="Victim Notification Attempt"
          show={notificationAttemptModal}
          onHide={handleNotificationAttemptModal}
          size="lg"
          footerActions={[
            {
              key: "save",
              text: "Save",
              onClick: saveNotificationLog,
            },
          ]}
          footerCloseAction
          footerCloseActionText={"Close"}
        >
          <VictimNotificationAttemptForm
            selectedVictim={selectedVictimLog}
            updateFormValue={updateFormValue}
          />
        </Modal>
      )}

      {isFolderSearchModal && (
        <FolderDetailSearchModal
          show={isFolderSearchModal}
          onSaveClick={handleSelectCurrentJacket}
          onHide={() => setIsFolderSearchModal(false)}
        />
      )}
    </>
  );
};

export default VictimNotificationDetails;
